import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Languages } from 'lucide-react';
import { useAuthStore } from '@/store/auth';

export function Login() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = useAuthStore((s) => s.accessToken);
  if (token) return <Navigate to="/" replace />;
  const isBlocked = params.get('error') === 'blocked';

  const authBase =
    (import.meta.env.VITE_AUTH_URL as string | undefined) ||
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ||
    '/api';
  const loginUrl = `${authBase.replace(/\/$/, '')}/auth/google`;
  const contactEmail = import.meta.env.VITE_CONTACT_EMAIL as string | undefined;

  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center px-6 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-600 text-white">
        <Languages className="h-8 w-8" />
      </div>
      <h1 className="text-2xl font-semibold">{t('app.name')}</h1>
      <p className="mt-2 text-slate-600">{t('login.tagline')}</p>
      {isBlocked && (
        <div className="mt-6 w-full rounded-lg border border-rose-200 bg-rose-50 p-4 text-left text-sm text-rose-900">
          <p className="font-medium">{t('login.blockedTitle')}</p>
          <p className="mt-1">{t('login.blockedMessage')}</p>
        </div>
      )}
      <div className="mt-8 w-full rounded-lg border border-amber-200 bg-amber-50 p-4 text-left text-sm text-amber-900">
        <p className="font-medium">{t('login.disclaimerTitle')}</p>
        <p className="mt-1">{t('login.disclaimer')}</p>
        {contactEmail && (
          <p className="mt-2">
            {t('login.disclaimerContact')}{' '}
            <a href={`mailto:${contactEmail}`} className="font-medium underline">
              {contactEmail}
            </a>
          </p>
        )}
      </div>
      <a href={loginUrl} className="btn-primary mt-4 w-full">
        {t('login.continueWithGoogle')}
      </a>
    </div>
  );
}
